const DepartmentsTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 90 },
    { id: 'name', labelAr: 'اسم القسم', labelEn: 'Department' },
    { id: 'parent_name', labelAr: 'القسم الأب', labelEn: 'Parent', width: 150 },
    { id: 'school_name', labelAr: 'المدرسة', labelEn: 'School', width: 150 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 100 },
];

export default DepartmentsTableColumns;
